import {
	createI18n
} from 'vue-i18n'
import zh from '@/i18n/zh'
import en from '@/i18n/en'
const i18n = new createI18n({
	// 从本地存储中取，如果没有默认为中文，
	// 这样可以解决切换语言后，没记住选择的语言，刷新页面后还是默认的语言
	locale: localStorage.getItem('lang') || 'zh',
	messages: {
		zh: {
			...zh
		}, // 中文语言包
		en: {
			...en
		} // 英文语言包
	},
	globalInjection: true,
	legacy: false,
	allowComposition: true
})
export default i18n